import { BrowserRouter, Routes, Route } from "react-router-dom";
import LicenseProvider from "./components/LicenseProvider";
import Register from "./pages/Register";
import Login from "./pages/Login";
import AdminLogin from "./pages/AdminLogin";
import UserLogin from "./pages/UserLogin";
import AgentLogin from "./pages/AgentLogin";
import Dashboard from "./pages/Dashboard";
import Bills from "./pages/Bills";
import ProtectedRoute from "./components/ProtectedRoute";
import SessionTimeout from "./components/SessionTimeout";
import Deposit from "./pages/Deposit";
import Withdraw from "./pages/Withdraw";
import Transfer from "./pages/Transfer";
import AdminDashboard from "./pages/AdminDashboard";
import Reports from "./pages/Reports";
import Notifications from "./pages/Notifications";
import QrReceive from "./pages/QrReceive";
import QrPay from "./pages/QrPay";
import AgentDeposit from "./pages/AgentDeposit";
import AgentWithdraw from "./pages/AgentWithdraw";
import AccountingDashboard from "./pages/AccountingDashboard";
import FeeManagement from "./pages/FeeManagement";
import SessionSettings from "./pages/SessionSettings";
import FeeSharingSettings from "./pages/FeeSharingSettings";
import LedgerQuery from "./pages/LedgerQuery";
import PinSetup from "./pages/PinSetup";
import ReconciliationReport from "./pages/ReconciliationReport";
import LicenseManagement from "./pages/LicenseManagement";
import TrialBalanceReport from "./pages/TrialBalanceReport";
import LiquidityPlanning from "./pages/LiquidityPlanning";
import UserBanking from "./pages/UserBanking";
import AgentBanking from "./pages/AgentBanking";
import CompanyFinance from "./pages/CompanyFinance";
import TransactionReversals from "./pages/TransactionReversals";
import BankAccounts from "./pages/BankAccounts";
import AccountTypeAdmin from "./pages/AccountTypeAdmin";
import ThirdPartyIntegrations from "./pages/ThirdPartyIntegrations";
import AdminEmail from './pages/AdminEmail';
import RiskManagement from './components/RiskManagement';
import KycAdmin from './components/KycAdmin';
import RoleManagement from './components/RoleManagement';
import AgentFloatManagement from './pages/AgentFloatManagement';
import AgentAccountOpening from './pages/AgentAccountOpening';
import BranchManagement from './pages/BranchManagement';
import BranchDashboard from './pages/BranchDashboard';
import CompanyProfile from './pages/CompanyProfile';
import AccountOpening from './pages/AccountOpening';
import BankAccountManagement from "./pages/BankAccountManagement";
import PendingKycAccounts from './pages/PendingKycAccounts';
import MerchantManagement from './pages/MerchantManagement';
import BillsTransactionsDashboard from './pages/BillsTransactionsDashboard';
import BillPaymentLimits from './pages/BillPaymentLimits';
import WalletSettings from './pages/WalletSettings';


function App() {
  return (
    <BrowserRouter>
      <LicenseProvider>
        <SessionTimeout>
          <Routes>
            {/* Public Routes - Login Pages */}
            <Route path="/register" element={<Register />} />
            <Route path="/user-login" element={<UserLogin />} />
            <Route path="/agent-login" element={<AgentLogin />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin-login" element={<AdminLogin />} />

            {/* User Internet Banking Portal */}
            <Route path="/user-banking" element={<ProtectedRoute><UserBanking /></ProtectedRoute>} />
            
            {/* Agent Internet Banking Portal */}
            <Route path="/agent-banking" element={<ProtectedRoute><AgentBanking /></ProtectedRoute>} />

            {/* Default route - User Login */}
            <Route path="/" element={<UserLogin />} />
            
            {/* Legacy/Utility routes */}
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/deposit" element={<ProtectedRoute><Deposit /></ProtectedRoute>} />
            <Route path="/withdraw" element={<ProtectedRoute><Withdraw /></ProtectedRoute>} />
            <Route path="/transfer" element={<ProtectedRoute><Transfer /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/bills" element={<ProtectedRoute><Bills /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/qr-receive" element={<ProtectedRoute><QrReceive /></ProtectedRoute>} />
            <Route path="/qr-pay" element={<ProtectedRoute><QrPay /></ProtectedRoute>} />
            <Route path="/agent/deposit" element={<ProtectedRoute><AgentDeposit /></ProtectedRoute>} />
            <Route path="/agent/withdraw" element={<ProtectedRoute><AgentWithdraw /></ProtectedRoute>} />
            <Route path="/agent/account-opening" element={<ProtectedRoute><AgentAccountOpening /></ProtectedRoute>} />
            <Route path="/pin-setup" element={<ProtectedRoute><PinSetup /></ProtectedRoute>} />
            <Route path="/integrations" element={<ThirdPartyIntegrations />} />

            {/* Admin Only Routes - Require Admin Login */}
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/accounting" element={<ProtectedRoute><AccountingDashboard /></ProtectedRoute>} />
            <Route path="/fees" element={<ProtectedRoute><FeeManagement /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><SessionSettings /></ProtectedRoute>} />
            <Route path="/fee-sharing" element={<ProtectedRoute><FeeSharingSettings /></ProtectedRoute>} />
            <Route path="/ledger-query" element={<ProtectedRoute><LedgerQuery /></ProtectedRoute>} />
            <Route path="/reconciliation-report" element={<ProtectedRoute><ReconciliationReport /></ProtectedRoute>} />
            <Route path="/license-management" element={<ProtectedRoute><LicenseManagement /></ProtectedRoute>} />
            <Route path="/trial-balance" element={<ProtectedRoute><TrialBalanceReport /></ProtectedRoute>} />
            <Route path="/liquidity-planning" element={<ProtectedRoute><LiquidityPlanning /></ProtectedRoute>} />
            <Route path="/company-finance" element={<ProtectedRoute><CompanyFinance /></ProtectedRoute>} />
            <Route path="/reversals" element={<ProtectedRoute><TransactionReversals /></ProtectedRoute>} />
            <Route path="/bank-accounts" element={<ProtectedRoute><BankAccounts /></ProtectedRoute>} />
            <Route path="/bank-account-management" element={<ProtectedRoute><BankAccountManagement /></ProtectedRoute>} />
            <Route path="/account-type-admin" element={<ProtectedRoute><AccountTypeAdmin /></ProtectedRoute>} />
            <Route path="/admin/email" element={<ProtectedRoute><AdminEmail /></ProtectedRoute>} />
            
            {/* Risk, KYC, and Role Management */}
            <Route path="/risk-management" element={<ProtectedRoute><RiskManagement /></ProtectedRoute>} />
            <Route path="/kyc-admin" element={<ProtectedRoute><KycAdmin /></ProtectedRoute>} />
            <Route path="/kyc" element={<ProtectedRoute><KycAdmin /></ProtectedRoute>} />
            <Route path="/role-management" element={<ProtectedRoute><RoleManagement /></ProtectedRoute>} />
            <Route path="/float-management" element={<ProtectedRoute><AgentFloatManagement /></ProtectedRoute>} />
            
            {/* Branch Management */}
            <Route path="/branch-management" element={<ProtectedRoute><BranchManagement /></ProtectedRoute>} />
            <Route path="/branch/:branchId" element={<ProtectedRoute><BranchDashboard /></ProtectedRoute>} />
            <Route path="/branch-dashboard/:branchId" element={<ProtectedRoute><BranchDashboard /></ProtectedRoute>} />
			
			             
            {/* Company & Account Opening */}
            <Route path="/company-profile" element={<ProtectedRoute><CompanyProfile /></ProtectedRoute>} />
            <Route path="/account-opening" element={<ProtectedRoute><AccountOpening /></ProtectedRoute>} />
			<Route path="/pending-kyc" element={<ProtectedRoute><PendingKycAccounts /></ProtectedRoute>} />
			<Route path="/merchant-management" element={<MerchantManagement />} />
            <Route path="/bills-transactions" element={<ProtectedRoute><BillsTransactionsDashboard /></ProtectedRoute>} />
            <Route path="/bill-payment-limits" element={<ProtectedRoute><BillPaymentLimits /></ProtectedRoute>} />
            <Route path="/wallet-settings" element={<ProtectedRoute><WalletSettings /></ProtectedRoute>} />
          </Routes>
        </SessionTimeout>
      </LicenseProvider>
    </BrowserRouter>
  );
}

export default App;

